(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["components"] = factory();
	else
		root["components"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 89);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _RadioInput = __webpack_require__(22);

var _RadioInput2 = _interopRequireDefault(_RadioInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(23);

var componentPropTypes = exports.componentPropTypes = {
  id: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  children: _propTypes2.default.any.isRequired
};

var LabelledRadio = function LabelledRadio(props) {
  return _react2.default.createElement(
    'div',
    { className: 'labelled-radio' },
    _react2.default.createElement(_RadioInput2.default, _extends({}, props, {
      customLabel: _react2.default.createElement(
        'label',
        {
          htmlFor: props.id,
          className: (0, _classnames2.default)('labelled-radio__label', props.className) },
        props.children,
        _react2.default.createElement('div', { className: 'labelled-radio__ie-click-target' })
      )
    }))
  );
};

LabelledRadio.propTypes = componentPropTypes;

exports.default = LabelledRadio;

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RadioInput = __webpack_require__(8);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RadioInput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("object.omit");

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentPropTypes = exports.oneOfProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _object = __webpack_require__(7);

var _object2 = _interopRequireDefault(_object);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

__webpack_require__(9);

var oneOfProps = exports.oneOfProps = {
  colour: ['green-light', 'green-medium', 'green-dark', 'yellow', 'pink', 'red', 'red-dark', 'purple', 'orange', 'blue']
};

var componentPropTypes = exports.componentPropTypes = {
  id: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  colour: _propTypes2.default.oneOf(oneOfProps.colour),
  label: _propTypes2.default.string,
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  customLabel: _propTypes2.default.node,
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

var RadioInput = function RadioInput(props) {
  var _classNames;

  var omitted = (0, _object2.default)(props, ['label', 'customLabel', 'children']);
  var handleOnChange = omitted.onChange || function () {};

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('radio-input', (_classNames = {}, _defineProperty(_classNames, 'color-' + props.colour, props.colour), _defineProperty(_classNames, 'radio-input--custom-label', !!props.customLabel), _classNames)) },
    _react2.default.createElement('input', _extends({
      type: 'radio'
    }, omitted, {
      onChange: handleOnChange
    })),
    !props.customLabel && [_react2.default.createElement('label', {
      key: 'style',
      htmlFor: props.id,
      className: 'radio-input__style'
    }), props.label && _react2.default.createElement(
      'label',
      {
        key: 'label',
        htmlFor: props.id,
        className: 'radio-input__label' },
      props.label
    )],
    props.customLabel && props.customLabel
  );
};

RadioInput.propTypes = componentPropTypes;

exports.default = RadioInput;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(21);


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/wonderbly-components/lib/LabelledRadio.js
// module id = 609
// module chunks = 0